/**
 * Layout: Password
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the product template.
 *
 */
import '@/styles/theme.scss';
/**
 * Password helpers.
 */

import EventBus from '~/helpers/event-bus';
/**
 * Password component imports.
 */

import Toggle from '~/components/toggle';
import { on } from '~/helpers/utils';
/**
 * Frame utils.
 */

window.Frame = window.Frame || {};
window.Frame.EventBus = EventBus();
/**
 * DOM selectors.
 */

const selectors = {
  container: '[js-password="container"]',
  landingContainer: '[js-password="landing"]',
  passwordForm: '[js-password="form"]',
  loginFormToggle: '[js-password="loginFormToggle"]',
  backToLanding: '[js-password="backToLanding"]'
};
document.addEventListener('DOMContentLoaded', () => {
  /**
   * Instantiate password form toggle.
   */
  const FormToggle = Toggle({
    toggleSelector: 'loginFormToggle',
    overlay: false,
    toggleTabIndex: false
  });
  FormToggle.init();
  /**
   * DOM node selectors.
   */

  const nodeSelectors = {
    container: document.querySelector(selectors.container),
    landingContainer: document.querySelector(selectors.landingContainer),
    passwordForm: document.querySelector(selectors.passwordForm),
    loginFormToggle: document.querySelector(selectors.loginFormToggle),
    backToLanding: document.querySelector(selectors.backToLanding)
  };
  /**
   * hide password form / show subsribing form
   * @param {Object} event - Click event handler.
   */

  function handleLoginFormToggle(event) {
    nodeSelectors.landingContainer.classList.remove('is-active');
    nodeSelectors.passwordForm.classList.add('is-active');
    event.preventDefault();
  }
  /**
   * show password form / hide subsribing form
   * @param {Object} event - Click event handler.
   */


  function handleBackToLanding(event) {
    nodeSelectors.passwordForm.classList.remove('is-active');
    nodeSelectors.landingContainer.classList.add('is-active');
    event.preventDefault();
  }
  /**
   * switch background image by screen size
   * @param {Object} event - Click event handler.
   */


  function handleBackground(event) {
    if (window.innerWidth <= 768) {
      nodeSelectors.container.style.backgroundImage = nodeSelectors.container.dataset.mobileBackground;
    } else {
      nodeSelectors.container.style.backgroundImage = nodeSelectors.container.dataset.desktopBackground;
    }

    event.preventDefault();
  }

  on('click', nodeSelectors.loginFormToggle, handleLoginFormToggle);
  on('click', nodeSelectors.backToLanding, handleBackToLanding);
  on('resize', window, handleBackground);
});